import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import {AvailableDays} from '@core/models';
import { NgClass } from '@angular/common';
import {WeekDaysInterface} from '@core/models/calendar/week-days.interface';

@Component({
    selector: 'app-week-days',
    templateUrl: './week-days.component.html',
    styleUrls: ['./week-days.component.scss'],
    imports: [
    NgClass
]
})
export class WeekDaysComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isDisabled: boolean = false;
  @Input() isView: boolean = false;
  public dayOfWeek: string[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  public activeDay!: AvailableDays;
  listener: () => void;
  @ViewChild('weekDays') week: ElementRef;
  @Output() changeDay: EventEmitter<AvailableDays> = new EventEmitter<AvailableDays>();

  @Input() set newActiveDay(data: AvailableDays) {
    if ((!data || !Object.keys(data).length) && this.isView) {
      this.isEmpty = true
      return;
    }

    this.activeDay = data;
    if (this.week) {
      const parent = this.week.nativeElement as HTMLElement;
      this.setActive(parent);
    }

    if (this.isView) {
      this.isEmpty = !Object.values(data).filter(value => value).length;
    }
  }

  public isEmpty: boolean = false;
  public lastActive: WeekDaysInterface = {
    sun: {
      value: 0,
      element: null
    },
    mon: {
      value: 0,
      element: null
    },
    tue: {
      value: 0,
      element: null
    },
    wed: {
      value: 0,
      element: null
    },
    thu: {
      value: 0,
      element: null
    },
    fri: {
      value: 0,
      element: null
    },
    sat: {
      value: 0,
      element: null
    }
  };

  constructor(
    private _renderer: Renderer2
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.isEmpty) return
    const parent = this.week?.nativeElement as HTMLElement;
    this.listener = this._renderer.listen(parent, 'click', this.checkDay.bind(this));
    this.setActive(parent);
  }

  checkDay(event): void {
    const elem = event.target;
    if (!this.isDisabled && elem.id) {
      const id = elem.id;
      if (!elem.classList.contains('active')) {
        this.lastActive[this.dayOfWeek[id]] = {
          value: 1,
          element: elem
        };
        this._renderer.addClass(elem, 'active');
      } else {
        this._renderer.removeClass(elem, 'active');
        this.lastActive[this.dayOfWeek[id]] = {
          value: 0,
          element: null
        };
      }
      this.changeDay.emit(this.prepareOutputValue(this.lastActive));
    }
  }

  private setActive(parent: HTMLElement): void {
    if (!this.activeDay) {
      return;
    }
    this.dayOfWeek.forEach(day => {
      if (this.activeDay[day]) {
        const activeChild = parent.children.item(this.dayOfWeek.indexOf(day));
        this._renderer.addClass(activeChild, 'active');
        this.lastActive[day] = {
          element: activeChild,
          value: 1
        };
      } else {
        if (!this.isView) {
          return;
        }
        this._renderer.removeChild(parent, parent.children.item(this.dayOfWeek.indexOf(day)));
      }
    });
  }

  private prepareOutputValue(days: WeekDaysInterface): AvailableDays {
    const weekDays: AvailableDays = {} as AvailableDays;
    for (const day in days) {
      weekDays[day] = days[day].value;
    }

    return weekDays;
  }

  ngOnDestroy(): void {
    if (this.isEmpty && this.isView) {
      return
    }
    this.listener();
  }
}
